import { ClubLocalModule } from '@modules/application/application';

export const BookingLocalModule: ClubLocalModule = {
    code: '5c8438bef7c60cf62b4a0aee3b0becc4',
    icon: 'book',
    localEnabled: true,
    name: 'Reservas',
    url: 'booking',
    includeInNavigation: true,
};
